import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { PlusIcon } from "@heroicons/react/24/outline";
import FeedbackTableDetails from "./FeedbackTableDetails";
import AddFeedbackForm from "./AddFeedbackForm";
import {
  deleteFeedbackById,
  fetchAllFeedback,
} from "../../../../redux/reducer/feedbackReducer";

const FeedbackSettings = () => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [pricingOrder, setPricingOrder] = useState(null);
  const dispatch = useDispatch();
  const { allFeedback, loading, error } = useSelector(
    (state) => state.feedback
  );
  const { t } = useTranslation();
  const [showForm, setShowForm] = useState(false); // <-- toggle form

  const headers = [
    "ID",
    "Name EN",
    "Name AR",
    "ShortDes EN",
    "ShortDes AR",
    "Rate",
    "Actions",
  ];

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(fetchAllFeedback());
    };

    fetchData();
  }, [dispatch]);

  const loadService = async () => {
    try {
      await dispatch(fetchAllFeedback()).unwrap();
    } catch (error) {
      console.error("Failed to fetch the Feedback:", error);
    }
  };

  const handleDelete = (ServiceId) => {
    if (window.confirm("Are you sure you want to delete this Feedback?")) {
      dispatch(deleteFeedbackById(ServiceId))
        .unwrap()
        .then(() => {
          dispatch(fetchAllFeedback());
        })
        .catch((error) => alert(error || "Failed to delete Feedback."));
    }
  };

  const handleUpdate = () => {
    dispatch(fetchAllFeedback());
  };
  // console.log(allFeedback)
  return (
    <div className="mx-auto overflow-x-auto rounded-xl">
      <div className="flex justify-between my-4">
        <h1 className="text-xl font-bold text-black">Feedback</h1>
        <button
          className="flex gap-3 px-3 py-2 duration-300 rounded-lg bg-custom-yellow hover:bg-black group"
          onClick={() => {
            setShowForm(true);
          }}
        >
          <PlusIcon className="w-6 h-6 text-black group-hover:text-white" />
          <span className="text-black group-hover:text-white">Feedback</span>
        </button>
      </div>

      {loading ? (
        <p className="text-center text-gray-600">{t("Loading...")}</p>
      ) : error ? (
        <p className="text-center text-red-500">
          {t("Error")}: {error}
        </p>
      ) : allFeedback?.length === 0 ? (
        <p className="text-center text-gray-500">{t("No data found")}</p>
      ) : (
        <table className="w-full my-5">
          <thead>
            <tr className="text-sm text-black bg-custom-yellow">
              {headers.map((header, index) => (
                <th key={index} className="px-2 py-2 font-bold text-center">
                  {header}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {allFeedback?.map((feedback, index) => (
              <FeedbackTableDetails
                key={feedback._id || index}
                index={index + 1}
                details={{
                  id: feedback._id,
                  number: index + 1,
                  name_en: feedback.name?.en,
                  name_ar: feedback.name?.ar,
                  desc_en: feedback.desc?.en,
                  desc_ar: feedback.desc?.ar,
                  rate: feedback.rate,
                }}
                isEditing={editingOrder === feedback._id}
                isPricing={pricingOrder === feedback._id}
                setEditingOrder={setEditingOrder}
                setPricingOrder={setPricingOrder}
                onUpdate={handleUpdate}
                onDelete={() => handleDelete(feedback._id)}
              />
            ))}
          </tbody>
        </table>
      )}
      {showForm && (
        <AddFeedbackForm
          onClose={() => {
            setShowForm(false);
            loadService();
          }}
        />
      )}
    </div>
  );
};

export default FeedbackSettings;
